<template>
  <div class="pv-overlay" @click.self="$emit('close')">

    <div v-if="variant === '3'" class="og-box">

      <!-- Header gradient cam -->
      <div class="og-header">
        <div class="og-header-left">
          <span class="og-badge">特急</span>
          <h3 class="og-title">審査を優先的に処理しませんか？</h3>
        </div>
        <button class="og-close" @click="$emit('close')">×</button>
      </div>

      <!-- Body -->
      <div class="og-body">

        <!-- Product chip -->
        <div class="og-product-chip">
          <img v-if="product.image" :src="product.image" class="og-product-thumb" alt="" />
          <div v-else class="og-product-thumb og-product-thumb--empty">📦</div>
          <div class="og-product-meta">
            <div class="og-product-name">{{ sliceName(product.productName) }}</div>
            <div class="og-product-asin">ASIN: {{ product.asin }}</div>
          </div>
        </div>

        <!-- Compare cards -->
        <div class="og-compare">
          <div class="og-compare-card og-compare-before">
            <div class="og-compare-label">通常プランの審査期間</div>
            <div class="og-compare-days">
              <span class="og-days-num">20</span>
              <span class="og-days-unit">日</span>
            </div>
            <div class="og-compare-sub">Basicプラン標準</div>
          </div>
          <div class="og-compare-arrow">
            <svg width="32" height="32" viewBox="0 0 32 32"><path d="M8 16h16m0 0l-6-6m6 6l-6 6" stroke="#e67e22" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
          <div class="og-compare-card og-compare-after">
            <div class="og-compare-label">特急チケット適用後</div>
            <div class="og-compare-days">
              <span class="og-days-num og-days-fast">3</span>
              <span class="og-days-unit">営業日</span>
            </div>
            <div class="og-compare-sub">Premiumプランと同等</div>
          </div>
        </div>

        <!-- Benefits -->
        <ul class="og-benefits">
          <li><span class="og-benefit-icon">⚡</span>審査完了まで最大<strong>17日短縮</strong>できます</li>
          <li><span class="og-benefit-icon">🚀</span>早期に<strong>出品開始</strong>し、販売機会を逃しません</li>
          <li><span class="og-benefit-icon">✅</span>この商品だけに適用 — プラン変更不要</li>
        </ul>

        <!-- Price row -->
        <div class="og-price-row">
          <div class="og-price-label">特急チケット</div>
          <div class="og-price-amount">
            <span class="og-price-currency">¥</span>
            <span class="og-price-num">{{ price.toLocaleString() }}</span>
            <span class="og-price-tax">（税込）</span>
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div class="og-footer">
        <button class="btn btn-default og-btn-cancel" @click="$emit('close')">キャンセル</button>
        <button class="btn og-btn-purchase" :disabled="loading" @click="handlePurchase">
          <span v-if="loading" class="og-spinner"></span>
          <span v-else><span class="og-ticket-icon">🎫</span> 特急チケットを購入する</span>
        </button>
      </div>

    </div>

    <div v-else-if="variant === '4'" class="og-box og4-box">

      <!-- Header xanh -->
      <div class="og-header og4-header">
        <div class="og-header-left">
          <span class="og-badge og4-badge">特急</span>
          <h3 class="og-title">審査を優先的に処理しませんか？</h3>
        </div>
        <button class="og-close" @click="$emit('close')">×</button>
      </div>

      <!-- Body -->
      <div class="og-body">

        <!-- Product chip -->
        <div class="og-product-chip">
          <img v-if="product.image" :src="product.image" class="og-product-thumb" alt="" />
          <div v-else class="og-product-thumb og-product-thumb--empty">📦</div>
          <div class="og-product-meta">
            <div class="og-product-name">{{ sliceName(product.productName) }}</div>
            <div class="og-product-asin">ASIN: {{ product.asin }}</div>
          </div>
        </div>

        <!-- Compare cards -->
        <div class="og-compare">
          <div class="og-compare-card og-compare-before">
            <div class="og-compare-label">通常プランの審査期間</div>
            <div class="og-compare-days">
              <span class="og-days-num">20</span>
              <span class="og-days-unit">日</span>
            </div>
            <div class="og-compare-sub">Basicプラン標準</div>
          </div>
          <div class="og-compare-arrow">
            <svg width="32" height="32" viewBox="0 0 32 32"><path d="M8 16h16m0 0l-6-6m6 6l-6 6" stroke="#008cc6" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
          <div class="og-compare-card og4-compare-after">
            <div class="og-compare-label">特急チケット適用後</div>
            <div class="og-compare-days">
              <span class="og-days-num og4-days-fast">3</span>
              <span class="og-days-unit">営業日</span>
            </div>
            <div class="og4-compare-sub">Premiumプランと同等</div>
          </div>
        </div>

        <!-- Benefits -->
        <ul class="og-benefits">
          <li><span class="og-benefit-icon">⚡</span>審査完了まで最大<strong>17日短縮</strong>できます</li>
          <li><span class="og-benefit-icon">🚀</span>早期に<strong>出品開始</strong>し、販売機会を逃しません</li>
          <li><span class="og-benefit-icon">✅</span>この商品だけに適用 — プラン変更不要</li>
        </ul>

        <!-- Price row -->
        <div class="og-price-row og4-price-row">
          <div class="og-price-label og4-price-label">特急チケット</div>
          <div class="og-price-amount">
            <span class="og-price-currency og4-price-text">¥</span>
            <span class="og-price-num og4-price-text">{{ price.toLocaleString() }}</span>
            <span class="og-price-tax">（税込）</span>
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div class="og-footer og4-footer">
        <button class="btn btn-default og-btn-cancel" @click="$emit('close')">キャンセル</button>
        <button class="btn og4-btn-purchase" :disabled="loading" @click="handlePurchase">
          <span v-if="loading" class="og-spinner"></span>
          <span v-else><span class="og-ticket-icon">🎫</span> 特急チケットを購入する</span>
        </button>
      </div>

    </div>

    <div v-else class="pv-dialog">

      <div class="pv-box" :class="variant === '2' ? 'pv-box--blue' : 'pv-box--orange'">

        <!-- Header -->
        <div class="pv-header">
          <span class="pv-sparkle pv-sparkle--tl" :class="variant === '2' ? 'pv-sparkle--blue' : 'pv-sparkle--yellow'">✦</span>
          <div class="pv-header-icon" :class="variant === '2' ? 'pv-icon--blue' : 'pv-icon--orange'">🎫</div>
          <div class="pv-header-title-wrap">
            <p class="pv-header-title">審査を優先処理<br>しませんか？</p>
            <div class="pv-header-underline" :class="variant === '2' ? 'pv-ul--blue' : 'pv-ul--yellow'"></div>
          </div>
        </div>

        <!-- Rows -->
        <div class="pv-rows">

          <div class="pv-row">
            <div class="pv-row-icon-wrap">
              <span class="pv-row-emoji">⏰</span>
              <span class="pv-sparkle pv-sparkle--icon" :class="variant === '2' ? 'pv-sparkle--blue' : 'pv-sparkle--yellow'">✦</span>
            </div>
            <div class="pv-row-text">
              通常のBasicプランでは<br>
              審査に<strong>20日</strong>かかります。
            </div>
          </div>

          <div class="pv-divider"></div>

          <div class="pv-row">
            <div class="pv-row-icon-wrap">
              <span class="pv-row-emoji">🚀</span>
            </div>
            <div class="pv-row-text">
              特急チケット適用で、<br>
              <span class="pv-accent-text" :class="variant === '2' ? 'pv-accent--blue' : 'pv-accent--red'">
                <strong>3営業日に短縮されます。</strong>
              </span>
              <div class="pv-text-underline" :class="variant === '2' ? 'pv-ul--blue' : 'pv-ul--yellow'"></div>
            </div>
            <span class="pv-sparkle pv-sparkle--row-r" :class="variant === '2' ? 'pv-sparkle--blue' : 'pv-sparkle--yellow'">✦</span>
          </div>

          <div class="pv-divider"></div>

          <div class="pv-row">
            <div class="pv-row-icon-wrap">
              <span class="pv-row-emoji">✅</span>
            </div>
            <div class="pv-row-text">
              この商品だけに適用。<br>プラン変更は不要です。
            </div>
          </div>

        </div>

        <!-- Callout box -->
        <div class="pv-callout" :class="variant === '2' ? 'pv-callout--blue' : 'pv-callout--orange'">
          <div class="pv-callout-top">
            <span class="pv-sparkle pv-sparkle--cbl" :class="variant === '2' ? 'pv-sparkle--blue' : 'pv-sparkle--yellow'">✦</span>
            <div class="pv-callout-icon-wrap" :class="variant === '2' ? 'pv-callout-icon--blue' : 'pv-callout-icon--orange'">💰</div>
            <div class="pv-callout-text">
              ご購入の前に、対象商品をご確認ください。<br>
              <span class="pv-callout-accent" :class="variant === '2' ? 'pv-accent--blue' : 'pv-accent--red'">
                特急チケット料金：¥{{ price.toLocaleString() }}（税込）
              </span>
            </div>
            <span class="pv-sparkle pv-sparkle--cbr" :class="variant === '2' ? 'pv-sparkle--blue' : 'pv-sparkle--yellow'">✦</span>
          </div>

          <div class="pv-product-chip">
            <img v-if="product.image" :src="product.image" class="pv-product-thumb" alt="" />
            <span v-else class="pv-product-thumb pv-product-thumb--empty">📦</span>
            <div>
              <div class="pv-product-name">{{ sliceName(product.productName) }}</div>
              <div class="pv-product-asin">ASIN: {{ product.asin }}</div>
            </div>
          </div>

          <div class="pv-callout-underline" :class="variant === '2' ? 'pv-ul--blue' : 'pv-ul--yellow'"></div>

          <button
            class="pv-cta-btn"
            :class="variant === '2' ? 'pv-cta--blue' : 'pv-cta--orange'"
            :disabled="loading"
            @click="handlePurchase"
          >
            <span v-if="loading" class="pv-spinner"></span>
            <template v-else>
              <span class="pv-cta-icon-left">🎫</span>
              特急チケットを購入する
              <span class="pv-cta-arrow">›</span>
            </template>
          </button>
        </div>

      </div>

      <!-- Footer outside box -->
      <div class="pv-footer">
        <button type="button" class="btn btn-default pv-close-btn" @click="$emit('close')">閉じる</button>
      </div>

    </div>

  </div><!-- /pv-overlay -->
</template>

<script>
export default {
  name: 'PriorityReviewModal',
  props: {
    product: { type: Object, default: () => ({}) },
    price: { type: Number, default: 980 },
    loading: { type: Boolean, default: false },
    variant: { type: String, default: '3' }
  },
  methods: {
    handlePurchase () {
      this.$emit('purchase', this.product)
    },
    sliceName (name) {
      if (!name) return ''
      return name.length > 55 ? name.slice(0, 55) + '…' : name
    }
  }
}
</script>

<style scoped>
/* ───────────────────────────────────
   SHARED OVERLAY
─────────────────────────────────── */
.pv-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.52);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.og-box {
  background: #fff;
  border-radius: 10px;
  width: 520px;
  max-width: 96vw;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.22);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: og-in 0.18s ease;
}
@keyframes og-in {
  from { transform: translateY(-14px); opacity: 0; }
  to   { transform: translateY(0);     opacity: 1; }
}

/* Header */
.og-header {
  background: linear-gradient(135deg, #e65c00 0%, #f9d423 100%);
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.og-header-left { display: flex; align-items: center; gap: 10px; }
.og-badge {
  background: #fff;
  color: #e65c00;
  font-weight: 900;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 20px;
  flex-shrink: 0;
  white-space: nowrap;
}
.og-title {
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0,0,0,0.18);
}
.og-close {
  background: rgba(255,255,255,0.25);
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  font-size: 18px;
  cursor: pointer;
  color: #fff;
  line-height: 1;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}
.og-close:hover { background: rgba(0,0,0,0.2); }

/* Body */
.og-body {
  padding: 18px 20px 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Product chip */
.og-product-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 8px 12px;
}
.og-product-thumb {
  width: 44px;
  height: 44px;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 4px;
}
.og-product-thumb--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  background: #eee;
}
.og-product-name { font-size: 12px; font-weight: bold; color: #333; line-height: 1.4; }
.og-product-asin { font-size: 11px; color: #888; margin-top: 2px; }

/* Compare cards */
.og-compare {
  display: flex;
  align-items: center;
  gap: 10px;
}
.og-compare-card {
  flex: 1;
  border-radius: 8px;
  padding: 12px 10px;
  text-align: center;
}
.og-compare-before { background: #f5f5f5; border: 1px solid #ddd; }
.og-compare-after  { background: linear-gradient(135deg, #fff8ee, #fff3e0); border: 2px solid #f09c2a; }
.og-compare-label  { font-size: 10px; color: #888; margin-bottom: 6px; font-weight: bold; }
.og-compare-days   { display: flex; align-items: baseline; justify-content: center; gap: 3px; }
.og-days-num       { font-size: 36px; font-weight: 900; color: #aaa; line-height: 1; }
.og-days-fast      { color: #e65c00; }
.og-days-unit      { font-size: 13px; color: #777; font-weight: bold; }
.og-compare-sub    { font-size: 10px; color: #aaa; margin-top: 4px; }
.og-compare-after .og-compare-sub { color: #e65c00; font-weight: bold; }
.og-compare-arrow  { flex-shrink: 0; }

/* Benefits */
.og-benefits {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.og-benefits li { display: flex; align-items: flex-start; gap: 8px; font-size: 13px; color: #444; }
.og-benefit-icon { font-size: 15px; flex-shrink: 0; margin-top: 1px; }

/* Price row */
.og-price-row {
  background: linear-gradient(90deg, #fff8ee, #fff3e0);
  border: 1px solid #f09c2a;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.og-price-label { font-size: 13px; font-weight: bold; color: #c0620a; }
.og-price-amount { display: flex; align-items: baseline; gap: 2px; }
.og-price-currency { font-size: 16px; font-weight: bold; color: #c0620a; }
.og-price-num { font-size: 30px; font-weight: 900; color: #c0620a; line-height: 1; }
.og-price-tax { font-size: 11px; color: #aaa; margin-left: 3px; }

/* Footer */
.og-footer {
  border-top: 1px solid #eee;
  padding: 12px 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: #fafafa;
}
.og-btn-cancel { font-size: 13px; color: #666; }
.og-btn-purchase {
  background: linear-gradient(135deg, #e65c00 0%, #f9d423 100%);
  color: #fff;
  font-weight: 800;
  font-size: 14px;
  border: none;
  padding: 9px 22px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 3px 10px rgba(230,92,0,0.35);
  min-width: 190px;
  justify-content: center;
  transition: filter 0.15s, transform 0.1s;
}
.og-btn-purchase:not(:disabled):hover { filter: brightness(1.08); transform: translateY(-1px); }
.og-btn-purchase:not(:disabled):active { transform: translateY(0); }
.og-btn-purchase:disabled { opacity: 0.65; cursor: not-allowed; }
.og-ticket-icon { font-size: 16px; }

/* Spinner */
.og-spinner {
  width: 16px; height: 16px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  display: inline-block;
  animation: pv-spin 0.7s linear infinite;
}

.pv-dialog {
  width: 480px;
  max-width: 96vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pv-box {
  width: 100%;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}
.pv-box--orange { border: 3px solid #1a3a6b; }
.pv-box--blue   { border: 3px solid #1a3a6b; }

/* Header */
.pv-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 20px 14px 16px;
  background: #fff;
  position: relative;
}
.pv-sparkle {
  position: absolute;
  font-size: 13px;
  font-style: normal;
  user-select: none;
  line-height: 1;
}
.pv-sparkle--yellow { color: #f5c518; }
.pv-sparkle--blue   { color: #008cc6; }
.pv-sparkle--tl    { top: 12px; left: 14px; font-size: 16px; }
.pv-sparkle--icon  { top: -6px; right: -6px; font-size: 10px; }
.pv-sparkle--row-r { right: 8px; top: 50%; transform: translateY(-50%); font-size: 11px; }
.pv-sparkle--cbl   { top: 8px; left: 8px; font-size: 11px; }
.pv-sparkle--cbr   { bottom: 50px; right: 8px; font-size: 11px; }

.pv-header-icon {
  width: 62px; height: 62px;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 28px;
  flex-shrink: 0;
  margin-top: 2px;
}
.pv-icon--orange { background: linear-gradient(135deg, #e65c00 0%, #f9d423 100%); box-shadow: 0 4px 12px rgba(230,92,0,0.38); }
.pv-icon--blue   { background: linear-gradient(135deg, #006fa6 0%, #008cc6 100%); box-shadow: 0 4px 12px rgba(0,140,198,0.38); }

.pv-header-title-wrap { flex: 1; min-width: 0; }
.pv-header-title { font-size: 22px; font-weight: 900; line-height: 1.35; color: #1a5fa8; margin: 0 0 8px; }

.pv-header-underline { height: 4px; border-radius: 2px; width: 100%; }
.pv-ul--yellow { background: linear-gradient(90deg, #f5c518, #f9a825); }
.pv-ul--blue   { background: linear-gradient(90deg, #008cc6, #00b4e8); }

/* Rows */
.pv-rows { padding: 0 16px; }
.pv-row { display: flex; align-items: flex-start; gap: 14px; padding: 14px 0; position: relative; }
.pv-row-icon-wrap { width: 46px; height: 46px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; position: relative; }
.pv-row-emoji { font-size: 30px; line-height: 1; }
.pv-row-text { flex: 1; font-size: 13px; color: #333; line-height: 1.65; padding-top: 2px; }
.pv-accent--red  { color: #d0021b; }
.pv-accent--blue { color: #006fa6; }
.pv-accent-text  { display: block; }
.pv-text-underline { height: 2px; border-radius: 1px; margin-top: 4px; width: 90%; }
.pv-divider { height: 1px; background: #e0e0e0; margin: 0 2px; }

/* Callout */
.pv-callout { margin: 12px 14px 14px; border-radius: 10px; padding: 14px; position: relative; }
.pv-callout--orange { border: 2px solid #1a5fa8; background: #fff; }
.pv-callout--blue   { border: 2px solid #008cc6; background: #f0f9ff; }
.pv-callout-top { display: flex; align-items: flex-start; gap: 12px; margin-bottom: 10px; position: relative; }
.pv-callout-icon-wrap { width: 46px; height: 46px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 22px; flex-shrink: 0; }
.pv-callout-icon--orange { background: #1a3a6b; }
.pv-callout-icon--blue   { background: #006fa6; }
.pv-callout-text { flex: 1; font-size: 13px; color: #333; line-height: 1.65; }
.pv-callout-accent { font-size: 14px; font-weight: 700; }
.pv-product-chip { display: flex; align-items: center; gap: 10px; background: #f7f7f7; border: 1px solid #e5e5e5; border-radius: 6px; padding: 7px 10px; margin-bottom: 10px; }
.pv-product-thumb { width: 38px; height: 38px; object-fit: contain; border-radius: 4px; flex-shrink: 0; }
.pv-product-thumb--empty { display: flex; align-items: center; justify-content: center; font-size: 20px; background: #ebebeb; }
.pv-product-name { font-size: 11px; font-weight: bold; color: #333; line-height: 1.4; }
.pv-product-asin { font-size: 10px; color: #888; margin-top: 2px; }
.pv-callout-underline { height: 3px; border-radius: 2px; margin-bottom: 12px; }

/* CTA */
.pv-cta-btn { width: 100%; border: none; border-radius: 50px; height: 52px; font-size: 16px; font-weight: 900; color: #fff; letter-spacing: 0.4px; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 10px; transition: filter 0.15s, transform 0.1s; position: relative; }
.pv-cta--orange { background: linear-gradient(135deg, #e65c00 0%, #f9d423 100%); box-shadow: 0 4px 16px rgba(230,92,0,0.4); }
.pv-cta--blue   { background: linear-gradient(135deg, #006fa6 0%, #008cc6 100%); box-shadow: 0 4px 16px rgba(0,140,198,0.4); }
.pv-cta-btn:not(:disabled):hover { filter: brightness(1.07); transform: translateY(-1px); }
.pv-cta-btn:not(:disabled):active { transform: translateY(0); }
.pv-cta-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.pv-cta-icon-left { font-size: 18px; }
.pv-cta-arrow { position: absolute; right: 18px; font-size: 24px; font-weight: 900; line-height: 1; }

/* Footer */
.pv-footer { display: flex; justify-content: center; margin-top: 10px; }
.pv-close-btn { padding: 5px 28px; font-size: 13px; }

/* Spinner (shared) */
.pv-spinner {
  width: 20px; height: 20px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  display: inline-block;
  animation: pv-spin 0.7s linear infinite;
}
@keyframes pv-spin { to { transform: rotate(360deg); } }

.og4-box {
  box-shadow: 0 12px 40px rgba(0, 140, 198, 0.18);
}
.og4-header {
  background: linear-gradient(135deg, #006fa6 0%, #008cc6 100%);
}
.og4-badge {
  color: #006fa6;
}
.og4-compare-after {
  background: linear-gradient(135deg, #e8f4fd, #d0ebf8);
  border: 2px solid #008cc6;
}
.og4-days-fast {
  color: #006fa6;
}
.og4-compare-sub {
  font-size: 10px;
  color: #006fa6;
  font-weight: bold;
  margin-top: 4px;
}
.og4-price-row {
  background: linear-gradient(90deg, #e8f4fd, #d0ebf8);
  border: 1px solid #008cc6;
}
.og4-price-label {
  color: #006fa6;
}
.og4-price-text {
  color: #006fa6;
}
.og4-footer {
  background: #f0f9ff;
  border-top: 1px solid #d0ebf8;
}
.og4-btn-purchase {
  background: linear-gradient(135deg, #006fa6 0%, #008cc6 100%);
  color: #fff;
  font-weight: 800;
  font-size: 14px;
  border: none;
  padding: 9px 22px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 3px 10px rgba(0, 140, 198, 0.35);
  min-width: 190px;
  justify-content: center;
  transition: filter 0.15s, transform 0.1s;
}
.og4-btn-purchase:not(:disabled):hover { filter: brightness(1.08); transform: translateY(-1px); }
.og4-btn-purchase:not(:disabled):active { transform: translateY(0); }
.og4-btn-purchase:disabled { opacity: 0.65; cursor: not-allowed; }
</style>



// WEBPACK FOOTER //
// src/view/productsNew/PriorityReviewModal.vue